export const baseURL = "https://royalsportsleague.com";

const config = {
    baseURL : baseURL,
    apiBaseURL : `${baseURL}/api/`,
    staticBaseURL: `${baseURL}/static/`,
    apiTimeout: 500000,
};

export default config;